import { MijnRoute } from '../../mijn-navigatie.model';

export const SELF_SERVICE_MESSAGE_PREFERENCES: MijnRoute = {
    path: 'berichtvoorkeuren',
    navigationEvent: 'toBerichtvoorkeuren',
    regex: /^\/zelf-regelen\/berichtvoorkeuren$/,
    webcomponent: 'mijn-klant-toestemmingen-webcomponent'
};
